import { Button, Col, Row } from "antd";
import React, { useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import { ROUTES } from "../../../constants";
import { useAppSelector } from "../../../redux/hooks";
import useDeleteImpactModal from "../../../hooks/useDeleteImpactModal";
import { getFormattedDateTime } from "../../../utils/commonUtils";
import DeleteConfirmationModal from "../../testExecutionSuit/modals/DeleteConfirmationModal";
import { TrashCanIcon } from "../../../components";
import { getDeleteImpact } from "../actions";

interface GeneratedTestcaseModuleListViewItemProps {
  module: any;
  deleteModule: (moduleId: string) => Promise<boolean>;
}
const GeneratedTestcaseModuleListViewItem = ({
  module,
  deleteModule,
}: GeneratedTestcaseModuleListViewItemProps) => {
  const accountId = useAppSelector(
    ({ userData }: any) => userData?.selectedAccount?.accountId,
  );
  const location: any = useLocation();
  const { projectId } = useParams<{ projectId?: string }>();
  const [deleteScript, setDeleteScript] = useState<boolean>(false);
  const [isDeleting, setDeleting] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    isModalOpen,
    affectedSuites,
    isImpactLoading,
    openDeleteModal,
    closeDeleteModal,
  } = useDeleteImpactModal({
    accountId,
    fetchDeleteImpact: getDeleteImpact,
    onClose: () => setDeleteScript(false),
  });
  const testCaseRender = () => {
    navigate(`${ROUTES.PROJECTS}/${projectId}/${module.moduleId}`, {
      state: {
        moduleId: module.moduleId,
        moduleName: module.name,
        projectName: location?.state?.projectName,
      },
    });
  };

  const handleDelete = async () => {
    if (!module?.moduleId || isDeleting) {
      return;
    }

    setDeleting(true);
    const isDeleted = await deleteModule(module.moduleId);
    if (isDeleted) {
      closeDeleteModal();
    }
    setDeleting(false);
  };

  return (
    <div className="fp_test_exec_list_item">
      <Row justify="space-between" className="fp_list_item">
        <Col span={8} onClick={() => testCaseRender()}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={24}>
              <p className="fp_testcase_name">{module.name}</p>
            </Col>
          </Row>
        </Col>
        <Col span={6} onClick={() => testCaseRender()}>
          <Row>
            <Col span={18}>
              <p>{getFormattedDateTime(module.createdAt)}</p>
            </Col>
          </Row>
        </Col>

        <Col span={4} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Row className="fp_test_exec_list_item_action">
            <Col>
              {deleteScript && (
                <Button
                  onClick={() =>
                    openDeleteModal({
                      moduleId: module.moduleId,
                    })
                  }
                  type="primary"
                  icon={deleteScript && <TrashCanIcon />}
                  className="fp_btn fp_btn-primary btn_delete"
                >
                  Delete Module
                </Button>
              )}
            </Col>
            <Col>
              <p>
                <MoreOutlined
                  onClick={() => setDeleteScript(!deleteScript)}
                  style={{ fontSize: "20px" }}
                />
              </p>
            </Col>
          </Row>
        </Col>
      </Row>

      <DeleteConfirmationModal
        title="Are you sure you want to delete this module?"
        deleteButtonText="Delete Module"
        isModalOpen={isModalOpen}
        warningMessage="Deleting this item will remove scripts from one or more test execution suites."
        affectedSuites={affectedSuites}
        isImpactLoading={isImpactLoading}
        handleCancel={closeDeleteModal}
        handleDelete={handleDelete}
        isLoading={isDeleting}
      />
    </div>
  );
};

export default GeneratedTestcaseModuleListViewItem;
